import { render, staticRenderFns } from "./RecentSaves.vue?vue&type=template&id=23ca2838&"
import script from "./RecentSaves.vue?vue&type=script&lang=ts&"
export * from "./RecentSaves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports